import { render } from "./Currency.vue?vue&type=template&id=f4d321c4&ts=true"
import script from "./Currency.vue?vue&type=script&lang=ts"
export * from "./Currency.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__